import { Component, OnInit } from '@angular/core';
declare var require: any;
import * as $ from 'jquery'
import 'fullcalendar';
import { KlixService } from '../services/klix.service';
var moment = require('moment');

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [KlixService]
})
export class CalendarComponent implements OnInit {
  events: any[] = [];
  blockedDates: string[] = []; // Dates indisponibles (format YYYY-MM-DD)
  tarifs: any[] = []; // Tarifs from backend
  tarifMap: any = {}; // Quick lookup by code
  defaultTarif: any = null; // Default tarif (first active one)
  client: any = { prenom: '', nom: '', mail: '', societe: '', adresse: '', codepostal: '', ville: '' };
  total = 0;
  remise5jours = 0;
  remiseClientRecurrent = 0;
  clientrecurrent = false;
  codepromo = '';
  vraicode = 'IKU-LOC';
  timeSlots: string[] = [];

  constructor(private klixService: KlixService) {
  }

  ngOnInit() {
    this.generateTimeSlots();

    // Charger les tarifs et les dates indisponibles en parallèle
    Promise.all([
      this.klixService.getTarifs(),
      this.klixService.getLocations()
    ]).then(([tarifs, locations]) => {
      // Stocker les tarifs
      this.tarifs = tarifs;
      this.tarifs.forEach(t => this.tarifMap[t.code] = t);
      this.defaultTarif = this.tarifMap['journee'] || (tarifs.length > 0 ? tarifs[0] : { code: 'journee', label: 'Journée', price: 290 });

      // Convertir en événements fullcalendar (fond rouge)
      locations.forEach(loc => {
        const dateStr = moment(loc.date).format('YYYY-MM-DD');
        this.blockedDates.push(dateStr);
        this.events.push({
          id: loc.id,
          start: dateStr,
          end: dateStr,
          rendering: 'background',
          color: '#dc3545',
          blocked: true
        });
      });
      this.initCalendar();
    }).catch(error => {
      console.error('Erreur chargement données:', error);
      // Fallback avec tarifs par défaut
      this.tarifs = [
        { code: 'journee', label: 'Journée', price: 290, priceTTC: 348 },
        { code: 'demi-journee', label: 'Demi-journée', price: 191, priceTTC: 230 },
        { code: 'heure', label: 'Heure', price: 58, priceTTC: 70 }
      ];
      this.tarifs.forEach(t => this.tarifMap[t.code] = t);
      this.defaultTarif = this.tarifMap['journee'];
      this.initCalendar();
    });
  }

  initCalendar() {
    $('#calendar').fullCalendar({
      locale: 'fr',
      defaultView: 'month',
      editable: false,
      eventLimit: true,
      aspectRatio: 1,
      events: this.events,
      dayClick: (date, jsEvent, view) => {
        const dateStr = date.format('YYYY-MM-DD');

        // Vérifier si la date est bloquée
        if (this.blockedDates.includes(dateStr)) {
          alert('Cette date n\'est pas disponible.');
          return;
        }

        // Toggle la sélection utilisateur (fond bleu)
        const existingSelection = this.events.find(e =>
          e.start === dateStr && e.backgroundColor === 'blue'
        );

        if (existingSelection) {
          // Désélectionner
          this.events = this.events.filter(e => e !== existingSelection);
        } else {
          // Sélectionner avec le tarif par défaut
          this.events.push({
            start: dateStr,
            end: dateStr,
            date: date.format('DD/MM/YYYY'),
            rendering: 'background',
            backgroundColor: 'blue',
            index: moment().format('YYYYMMDDHHmmssSSS'),
            sel: this.defaultTarif.code,
            amount: this.defaultTarif.price
          });
        }
        this.majCalendar();
        this.calculTotal();
      },
      hiddenDays: [],
      weekNumbers: false,
      allDaySlot: false,
    });
  }

  calculTotal() {
    let total = 0;
    let selections = this.events.filter(e => e.backgroundColor === 'blue');
    selections.forEach(event => {
      total += event.amount;
    });
    this.remise5jours = Math.round(((selections.length >= 5) ? total * 0.1 : 0) * 100) / 100;
    this.remiseClientRecurrent = Math.round(((this.clientrecurrent) ? total * 0.1 : 0) * 100) / 100;
    this.total = Math.round((total - this.remise5jours - this.remiseClientRecurrent) * 100) / 100;
  }

  ancienClient() {
    this.clientrecurrent = this.codepromo == this.vraicode;
    this.calculTotal();
  }

  choose(tarifCode: string, todo: any) {
    const tarif = this.tarifMap[tarifCode];
    if (!tarif) return;

    todo.sel = tarifCode;

    if (tarifCode === 'journee') {
      todo.amount = tarif.price;
      todo.period = null;
      todo.heureDebut = null;
      todo.heureFin = null;
      todo.nbHeures = null;
    } else if (tarifCode === 'demi-journee') {
      todo.amount = tarif.price;
      todo.period = todo.period || 'matin';
      todo.heureDebut = null;
      todo.heureFin = null;
      todo.nbHeures = null;
    } else if (tarifCode === 'heure') {
      todo.period = null;
      todo.heureDebut = todo.heureDebut || '09h00';
      todo.heureFin = todo.heureFin || '11h00';
      this.calculateHourlyAmount(todo);
    }
    this.calculTotal();
  }

  choosePeriod(period: string, todo: any) {
    todo.period = period;
  }

  updateHeures(todo: any) {
    // Enforce minimum 2h
    const start = this.timeToMinutes(todo.heureDebut);
    const end = this.timeToMinutes(todo.heureFin);
    if (end - start < 120) {
      todo.heureFin = this.minutesToTime(start + 120);
    }
    this.calculateHourlyAmount(todo);
    this.calculTotal();
  }

  calculateHourlyAmount(todo: any) {
    const tarif = this.tarifMap['heure'];
    if (!tarif || !todo.heureDebut || !todo.heureFin) return;

    const start = this.timeToMinutes(todo.heureDebut);
    let end = this.timeToMinutes(todo.heureFin);
    if (end - start < 120) {
      end = start + 120;
      todo.heureFin = this.minutesToTime(end);
    }
    todo.nbHeures = (end - start) / 60;
    todo.amount = Math.round(tarif.price * todo.nbHeures * 100) / 100;
  }

  generateTimeSlots() {
    this.timeSlots = [];
    for (let h = 8; h <= 18; h++) {
      for (let m = 0; m < 60; m += 30) {
        if (h === 8 && m === 0) continue; // start at 8h30
        this.timeSlots.push(this.minutesToTime(h * 60 + m));
      }
    }
  }

  getEndTimeSlots(heureDebut: string): string[] {
    if (!heureDebut) return this.timeSlots;
    const startMin = this.timeToMinutes(heureDebut) + 120; // minimum 2h after
    return this.timeSlots.filter(t => this.timeToMinutes(t) >= startMin);
  }

  getStartTimeSlots(): string[] {
    // Start slots: up to 16h00 (to allow min 2h before 18h00)
    return this.timeSlots.filter(t => this.timeToMinutes(t) <= 16 * 60);
  }

  timeToMinutes(time: string): number {
    const parts = time.split('h');
    return parseInt(parts[0]) * 60 + parseInt(parts[1]);
  }

  minutesToTime(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return h.toString().padStart(2, '0') + 'h' + m.toString().padStart(2, '0');
  }

  majCalendar() {
    var mycal: any = $(`#calendar`);
    mycal.fullCalendar('removeEvents');
    $(`#calendar`).fullCalendar('addEventSource', this.events);
  }

  getSelections() {
    return this.events.filter(e => e.backgroundColor === 'blue');
  }

  demandeDevis() {
    const selections = this.getSelections();

    if (selections.length === 0) {
      alert('Veuillez sélectionner au moins une date.');
      return;
    }

    if (!this.client.prenom || !this.client.nom || !this.client.mail) {
      alert('Veuillez remplir votre prénom, nom et email.');
      return;
    }

    // Créer le devis via le backend
    const devisData = {
      prenom: this.client.prenom,
      nom: this.client.nom,
      email: this.client.mail,
      societe: this.client.societe,
      adresse: this.client.adresse,
      codePostal: this.client.codepostal,
      ville: this.client.ville,
      total: this.total,
      remise5jours: this.remise5jours,
      remiseClientRecurrent: this.remiseClientRecurrent,
      dates: selections.map(s => ({
        date: s.start,
        dateStr: s.date,
        sel: s.sel === 'demi-journee' ? (s.period || 'matin') :
             s.sel === 'heure' ? 'heure:' + s.heureDebut + '-' + s.heureFin :
             s.sel,
        amount: s.amount
      }))
    };

    this.klixService.createDevis(devisData)
      .then(devis => {
        alert('Votre demande de devis a été envoyée ! Nous vous contacterons rapidement.');
        // Reset selections
        this.events = this.events.filter(e => e.blocked);
        this.majCalendar();
        this.calculTotal();
        // Reset form
        this.client = { prenom: '', nom: '', mail: '', societe: '', adresse: '', codepostal: '', ville: '' };
      })
      .catch(error => {
        console.error('Erreur création devis:', error);
        alert('Une erreur est survenue. Veuillez réessayer.');
      });
  }

  replaceAll(string, stringToChange, changeWith) {
    for (var i = 0; i < 1000; i++)
      string = string.replace(stringToChange, changeWith);
    return string;
  }
}
